import {PipeTransform, Pipe, Component} from '@angular/core';

@Pipe({
  name: 'fill'
})
export class FillPipe implements PipeTransform {
  transform(value, asString: boolean = false) {
    let arr = [];
    for (let i = 0; i < value; i++) {
      arr[i] = i + 1;
    }
    return arr;
  }
}
